import { useLocation } from '@tanstack/react-router';

import { useBoolean } from './use-boolean';

export const useEdit = (forceEdit = false) => {
  const { state } = useLocation();

  return useBoolean(state?.isFromNew ?? forceEdit);
};
